import React from 'react';
import styled from 'styled-components';
import { useStandardAlertStore } from '../../shared/store/portal/alertStore';
import { getAlertMessage } from '../../shared/constants/alertMessages';
import { AlertPosition, AlertType, DeviceType } from '../../shared/enum/EnumRepository';
import { WorkFilterData } from '../../shared/dto/EntityRepository';
import { useDeviceStore } from '../../shared/store/deviceStore';
import { generateYearOptions } from '../../shared/util/yearOptions';

const yearOptions = generateYearOptions();

interface FilterStationWorkTypeProps {
  currentFilter: WorkFilterData;
  setCurrentFilter: (filter: WorkFilterData) => void;
}

const FilterStationWorkType: React.FC<FilterStationWorkTypeProps> = ({ currentFilter, setCurrentFilter }) => {
  const { enqueueAlert } = useStandardAlertStore();
  const { deviceType } = useDeviceStore();

  const handleMinChange = (value: string) => {
    const minValue = value === 'All' ? null : Number(value);

    // START가 END보다 클 수 없도록 검사
    if (minValue !== null && currentFilter.prodYear.max !== null && minValue > currentFilter.prodYear.max) {
      enqueueAlert({
        type: AlertType.ALERT,
        position: AlertPosition.TOP,
        content: getAlertMessage('START_YEAR_GREATER_THAN_END'),
        callBack: () => { }
      });
      return; // 유효하지 않은 값이면 변경하지 않음
    }

    setCurrentFilter({
      ...currentFilter,
      prodYear: {
        ...currentFilter.prodYear,
        min: minValue
      }
    });
  };

  const handleMaxChange = (value: string) => {
    const maxValue = value === 'All' ? null : Number(value);

    // END가 START보다 작을 수 없도록 검사
    if (maxValue !== null && currentFilter.prodYear.min !== null && maxValue < currentFilter.prodYear.min) {
      enqueueAlert({
        type: AlertType.ALERT,
        position: AlertPosition.TOP,
        content: getAlertMessage('END_YEAR_SMALLER_THAN_START'),
        callBack: () => { }
      });
      return; // 유효하지 않은 값이면 변경하지 않음
    }

    setCurrentFilter({
      ...currentFilter,
      prodYear: {
        ...currentFilter.prodYear,
        max: maxValue
      }
    });
  };

  return (
    <WorkTypeFilterComp>
      <WorkImportSubTitle $isMobile={deviceType === DeviceType.MOBILE}>Production Year</WorkImportSubTitle>
      <YearSection>
        <YearSelectContainer>
          <YearSelect
            value={currentFilter.prodYear.min?.toString() || 'All'}
            onChange={(e) => handleMinChange(e.target.value)}
          >
            <option value="All">START</option>
            {yearOptions.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </YearSelect>
        </YearSelectContainer>
        <Dash>-</Dash>
        <YearSelectContainer>
          <YearSelect
            value={currentFilter.prodYear.max?.toString() || 'All'}
            onChange={(e) => handleMaxChange(e.target.value)}
          >
            <option value="All">END</option>
            {yearOptions.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </YearSelect>
        </YearSelectContainer>
      </YearSection>
    </WorkTypeFilterComp>
  );
};

export default FilterStationWorkType;

export const WorkImportSubTitle = styled.div<{ $isMobile: boolean }>`
  margin-bottom: ${({ $isMobile }) => $isMobile ? '2vh' : '1.2vh'};
  ${({ theme, $isMobile }) => $isMobile ? theme.typography.Body_02_1 : theme.typography.Body_03_1};
`

const WorkTypeFilterComp = styled.div`
  display: flex;
  flex-direction: column;
`
export const YearSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_02_2};
`;

export const Dash = styled.div`
  width: fit-content;
  margin: 0 1vw;
  padding: 5px 0px;
`;

export const Year = styled.div`
  width: 2.3rem;
  min-width: 2rem;
  padding: 5px 0px;
`;

const YearSelectContainer = styled.div`
  flex: 1;
  min-width: 0;
`;

const YearSelect = styled.select`
  width: 100%;
  height: fit-content;
  padding: 5px 0px 4px 0px;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
  border-radius: 0;
  background: transparent;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
  cursor: pointer;

  option {
    color: ${({ theme }) => theme.colors.color_Gray_04};
  }
`;
